import { Box, Typography } from '@mui/material';
import React from 'react';

import logo from '../../../assets/img/pruff9.svg';

const ProcessDialogFooter: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        py: 1.5,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        powered by
      </Typography>
      <Box
        component="img"
        src={logo}
        alt="Pruff"
        sx={{ height: 16, width: 'auto', display: 'block' }}
      />
    </Box>
  );
};

export default ProcessDialogFooter;
